export const COLUMNS = [
  {
    Header: 'Offer',
    accessor: 'name',
  },
  {
    Header: 'Type',
    accessor: 'type',
  },
  {
    Id: 'Id',
    accessor: '_id',
  },
  {
    Header: 'Discount',
    accessor: 'discountPrecentage',
  },
  {
    Header: 'Expire',
    accessor: 'expireDate',
  },
  {
    Header: 'Edit/Delete',
    accessor: '',
  },
];
